import { Box } from '@mui/material'
import React from 'react'

const ViewPurchaseOrder = ({ base64 }) => {
    return (
        <Box p={2}>
            {base64 &&
                <iframe
                    allowFullScreen
                    width="100%"
                    style={{ border: "none", flex: 1 }}
                    height={"1000px"}
                    src={`data:text/html;base64,${base64}`}
                />
            }
        </Box>
    )
}

export default ViewPurchaseOrder